import { useEffect, useState } from "react";
import { StatusesAPI } from "../../api/admin";

export default function StatusList() {
  const [statuses, setStatuses] = useState([]);
  const [newName, setNewName] = useState("");
  const [newColour, setNewColour] = useState("#999999");
  const [error, setError] = useState(null);

  useEffect(() => {
    loadStatuses();
  }, []);

  async function loadStatuses() {
    try {
      const res = await StatusesAPI.list();
      setStatuses(res);
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleCreate(e) {
    e.preventDefault();
    try {
      await StatusesAPI.create({ name: newName, colour: newColour });
      setNewName("");
      await loadStatuses();
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm("Delete this status?")) return;
    try {
      await StatusesAPI.delete(id);
      await loadStatuses();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Manage Ticket Statuses</h1>
      {error && <p className="text-red-500">{error}</p>}

      <form onSubmit={handleCreate} className="flex gap-2 mb-4">
        <input
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="New status name"
          className="border rounded p-2 flex-1" />
        <input type="color" value={newColour} onChange={e=>setNewColour(e.target.value)} className="border rounded p-2 w-16"
        />
        <button
          type="submit"
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          Add
        </button>
      </form>

      <ul className="border rounded divide-y">
        {statuses.map((s) => (
          <li key={s.id} className="flex justify-between items-center p-2">
            <span className="inline-flex items-center gap-2"><span className="inline-block w-4 h-4 rounded" style={{background:s.colour}}></span>{s.name}</span>
            <button
              onClick={() => handleDelete(s.id)}
              className="text-red-600 hover:underline"
            >
              Delete
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}